export const PaymentEndpoints = {
  makeManualPayment: "/manual",
  confirmManualPayIntent: "/manual/confirm-pay-intent/:id",
  cancelManualPayIntent: "/manual/cancel-pay-intent",
  getManualPaymentHistory: "/manual/history",
  // Pay by Bank — a PaymentIntent-only endpoint (no server-side .confirm()),
  // see services/payment/src/controllers/manual.ts's createPayByBankPay.
  // Deliberately NOT richAuth-gated: Stripe's bank-selection UI can't
  // render at all until this PaymentIntent (its clientSecret) exists, so
  // gating creation itself would force the WebAuthn step-up before the
  // admin has even seen the bank UI. The step-up instead happens right
  // before the actual payment confirm — see verifyManualPayByBankAuth.
  createManualPayByBankIntent: "/manual/pay-by-bank",
  // richAuth-only checkpoint (no side effect beyond the auth check itself)
  // called by PayByBank.vue immediately before stripe.confirmPayment() —
  // Stripe's own confirm call is a direct browser-to-Stripe request with
  // no backend hop of ours to gate, so this is the last point our backend
  // can verify admin identity before the bank redirect happens.
  verifyManualPayByBankAuth: "/manual/pay-by-bank/verify",

  addPaymentMethod: "/methods",
  getPaymentMethods: "/methods",
  deletePaymentMethods: "/methods/:id",
  getCarerWallet: "/carer",
  getCarerWalletById: "/carer/:id",
  payCarer: "/pay",

  // Booking Pay by Bank is called directly by the client portal, bypassing
  // the usual client-service gRPC relay — Pay by Bank needs a client_secret
  // in the browser to mount Stripe's Payment Element, and there was no
  // existing HTTP surface on the payment service for booking payments to
  // build that relay through.
  createBookingPayByBankIntent: "/booking/pay-by-bank",
};
